import { render } from "./Adr.vue?vue&type=template&id=1702cb92&scoped=true"
import script from "./Adr.vue?vue&type=script&lang=js"
export * from "./Adr.vue?vue&type=script&lang=js"

import "./Adr.vue?vue&type=style&index=0&id=1702cb92&lang=scss"
import "./Adr.vue?vue&type=style&index=1&id=1702cb92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1702cb92"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QScrollArea});
